import withTranslation from "next-translate/withTranslation"
import { ReactNode } from "react"
import { FormGroup, Input, Label } from "reactstrap"

import FAQPopup from "@components/common/faq/FAQPopup"

import FormikElement, { IBaseFormikProps } from "./FormikElement"

/**
 * a list of selection options to be used within a FormikSelect form element
 */
export interface FormikSelectOptions {
  [label: string]: string | number
}


interface IProps extends IBaseFormikProps {
  children: ReactNode
  className: string
  name: string
  noGroup?: boolean
  options: FormikSelectOptions
  placeholder?: string
  value?: any
}

/**
 * this component provides a Formik-based dropdown-select element
 */
class FormikSelect extends FormikElement<IProps> {
  public render = (): ReactNode => {
    // extract all properties not allowed / not needed for the input element so the don't get
    // passed down and appear in the HTML
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children, field, form, help, id, label, meta, noGroup = false, options,
      placeholder, value, ...props } = this.props
    const labelText = this.labelText()

    const optionElements: JSX.Element[] = []
    Object.keys(options).forEach((optionLabel) => {
      optionElements.push(<option key={options[optionLabel]} value={options[optionLabel]}>{optionLabel}</option>)
    })

    const element = <>
      <div>
        {labelText.length > 0 && <Label for={field.name}>{labelText}</Label> /* the label of the form-element */}
        {this.props.faqpopup && /* set an faq-popup, if given */
          <FAQPopup {...this.props.faqpopup} />
        }
        {this.helpElement()}
      </div>
      <Input
        {...field}
        {...props}
        id={id || field.name}
        name={field.name}
        invalid={this.hasError()}
        placeholder={placeholder ? this.props.i18n.t(placeholder) : null}
        type={"select"}
        value={value === null ? "" : value}
      >
        {optionElements}
      </Input>

      {this.errorElement()}
    </>

    return noGroup ? element : <FormGroup>{element}</FormGroup>
  }
}

export default withTranslation(FormikSelect, "common")
